import React from 'react'
import { IonCol } from '@ionic/react'
import classnames from 'classnames'

import { getDirMode } from '../../platform'
import { useCollectionDownload } from '../../offline/useDownload'
import strings from '../../../strings'
import { downloadRowState } from '../functions'
import { Text } from '@mytours/components'

interface Props {
	collectionId: number
	/** A tour saved in another language is not this tour saved, so it earns no chip here. */
	language: string
}

/**
 * That this tour is already on the device, said in the heading's row of facts about it.
 *
 * The single page layout's download control stands down once a tour is saved, so this is what is left to
 * say it — beside the stop count and the walking time rather than as a control, because by then it is a
 * property of the tour and not something to act on.
 */
const TourDownloadedChip: React.FC<Props> = ({ collectionId, language }) => {
	const { status, language: savedLanguage } = useCollectionDownload(collectionId)

	if (!downloadRowState(status, savedLanguage, language).saved) return null

	return (
		<IonCol className="data">
			<i className={classnames('icon', getDirMode(), 'fas fa-circle-check')} />
			<Text variant="inherit" className="label">
				{strings.downloaded_tour}
			</Text>
		</IonCol>
	)
}

export default TourDownloadedChip
